import { render, staticRenderFns } from "./section-collection.vue?vue&type=template&id=45d1dd81&scoped=true"
import script from "./section-collection.vue?vue&type=script&lang=js"
export * from "./section-collection.vue?vue&type=script&lang=js"
import style0 from "./section-collection.vue?vue&type=style&index=0&id=45d1dd81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1dd81",
  null
  
)

export default component.exports